var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownTriangleIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18745 14.2695C9.5861 14.8305 10.4191 14.8305 10.8178 14.2695L14.6539 8.87089C15.1244 8.20878 14.651 7.29166 13.8388 7.29166L6.16644 7.29166C5.35419 7.29166 4.8808 8.20878 5.35129 8.8709L9.18745 14.2695Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownTriangleIc);
export default __webpack_public_path__ + "static/media/downTriangleIc.874cce7c7eb5f71c8f1b8ff5ca4c1311.svg";
export { ForwardRef as ReactComponent };